// Valeurs de production (app.wheriz.co). C'est le fichier de base : les autres
// environnements le remplacent via `fileReplacements` dans angular.json.
export const environment = {
  apiBase: 'https://wheriz-api.my-accolades.fr',
  baseUrl: 'https://app.wheriz.co'
};
